import React, { useState } from 'react';
import { Alert, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useSystemConfig } from '../hooks/useSystemConfig';

const DISMISSED_KEY = 'announcement.dismissed';

function hashMessage(text: string): string {
  let h = 0;
  for (let i = 0; i < text.length; i += 1) h = (h * 31 + text.charCodeAt(i)) | 0;
  return String(h);
}

/** Admin-set announcement (System Settings). Dismissing hides it until the message changes. */
const AnnouncementBanner: React.FC = () => {
  const { announcement } = useSystemConfig();
  const [dismissed, setDismissed] = useState(() => {
    try {
      return localStorage.getItem(DISMISSED_KEY);
    } catch {
      return null;
    }
  });
  if (!announcement) return null;
  const id = hashMessage(`${announcement.severity}|${announcement.message}|${announcement.link_url}`);
  if (dismissed === id) return null;

  const dismiss = () => {
    try {
      localStorage.setItem(DISMISSED_KEY, id);
    } catch {
      /* private mode */
    }
    setDismissed(id);
  };
  const url = announcement.link_url;
  const action =
    url && announcement.link_label ? (
      url.startsWith('/') ? (
        <Button color="inherit" size="small" component={RouterLink} to={url}>
          {announcement.link_label}
        </Button>
      ) : (
        <Button color="inherit" size="small" href={url} target="_blank" rel="noopener noreferrer">
          {announcement.link_label}
        </Button>
      )
    ) : undefined;

  return (
    <Alert severity={announcement.severity} onClose={dismiss} action={action} sx={{ mb: 2, alignItems: 'center' }}>
      {announcement.message}
    </Alert>
  );
};

export default AnnouncementBanner;
